// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/_vue-style-loader@2.0.5@vue-style-loader!./~/_css-loader@0.26.4@css-loader?{"minimize":true,"sourceMap":true}!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-0566967c","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@6.0.7@sass-loader/lib/loader.js?{"sourceMap":true}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=1!./src/views/Home.vue
// module id = 880
// module chunks = 41